<template>
  <PropertyDetailsCardRows>
    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.rent"
      label="Monthly rent"
      icon="currency-dollar-circle"
      :value="`$${property?.leaseConditions?.rent}`"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.securityDeposit"
      label="Security deposit"
      icon="bank-note-01"
      :value="property?.leaseConditions?.securityDeposit"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.applicationProvider"
      label="Application provider"
      icon="file-check-02"
      :value="property?.leaseConditions?.applicationProvider"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.applicationFee"
      label="Application fee"
      icon="wallet-02"
      :value="`$${property?.leaseConditions?.applicationFee}`"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.applicationCoSignerFee"
      label="Application co-signer fee"
      icon="users-01"
      :value="`$${property?.leaseConditions?.applicationCoSignerFee}`"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.leaseConditions?.otherFees"
      label="Other fees"
      icon="receipt"
      :value="property?.leaseConditions?.otherFees"
    />
  </PropertyDetailsCardRows>
</template>

<script setup lang="ts">
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

defineProps<{
  property: PropertyDto | null | undefined;
}>();
</script>
